import { styled } from 'linaria/react';
import MaxWidth from '../../components/Layout/MaxWidth';
import { theme } from '../../components/Theme';
import { toRem } from '../../helpers';
import Heading from '../../components/ui/Heading';

const ContentBlockContainer = styled(MaxWidth)`
  padding: 0;
  display: block;

  ${theme.above.lg} {
    padding-right: var(--layout-gutter, ${toRem(36)});
    padding-left: var(--layout-gutter, ${toRem(36)});
  }
`;

const ContentBlockWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 0 0 50%;
  padding: var(--layout-gutter, ${toRem(20)});
  background-color: ${theme.colorScheme.darkgrey};
  ${theme.above.sm} {
    flex-direction: row;
  }
`;

const InnerWrapper = styled('div')`
  height: 100%;
  min-height: ${toRem(357)};
  padding: ${toRem(24)} ${toRem(24)} ${toRem(37)} ${toRem(24)};
  position: relative;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: ${props => (props.hasIcon ? 'space-between' : 'flex-end')};
  z-index: 5;
  ${theme.above.sm} {
    min-height: ${toRem(356)};
  }
`;

const IconImage = styled('img')`
  width: ${toRem(32)};
  height: ${toRem(32)};
  margin-bottom: ${toRem(20)};
`;

const ImageWrapper = styled('div')`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  ${theme.above.lg} {
    > div {
      transform: scale(1);
      animation: imgZoomOut 0.3s;
      transition-timing-function: ease-in-out;
    }
  }

  @keyframes imgZoomOut {
    from {
      transform: scale(1.08);
    }
    to {
      transform: scale(1);
    }
  }
`;
const TextCTAWrapper = styled('div')``;

const Title = styled(Heading)`
  margin-bottom: ${toRem(18)};
  font-size: ${toRem(24)};
  line-height: ${toRem(25)};
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colorScheme.white};

  ${theme.above.sm} {
    max-width: 75%;
  }

  ${theme.above.md} {
    max-width: 65%;
  }

  ${theme.above.xl} {
    max-width: 50%;
  }
`;

const Text = styled('p')`
  line-height: ${toRem(22)};
  color: ${theme.colorScheme.white};
  margin-bottom: ${toRem(32)};

  ${theme.above.xs} {
    max-width: 60%;
  }

  ${theme.above.sm} {
    max-width: 75%;
  }

  ${theme.above.md} {
    max-width: 65%;
  }

  ${theme.above.xl} {
    max-width: 50%;
  }
`;

const FrostedGlass = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  overflow: hidden;

  ::before {
    content: '';
    width: ${toRem(700)};
    height: ${toRem(700)};
    position: absolute;
    top: 0;
    left: ${toRem(-400)};
    background: rgba(0, 0, 0, 0.5);
    transform: rotate(-18deg);
    backdrop-filter: blur(4px);

    ${theme.above.xs} {
      left: ${toRem(-433)};
    }

    ${theme.above.lg} {
      left: ${toRem(-400)};
    }
    ${theme.above.xl} {
      left: ${toRem(-345)};
    }
  }
`;

const ContentItemWrapper = styled('div')`
  min-height: ${toRem(357)};
  position: relative;
  margin-bottom: ${toRem(16)};

  &:last-child {
    margin-bottom: 0;
  }

  ${theme.above.sm} {
    min-height: ${toRem(356)};
    flex: 1;
    margin-bottom: 0;
    margin-right: ${toRem(16)};

    &:last-child {
      margin-right: 0;
    }
  }

  ${theme.above.lg} {
    :hover {
      ${ImageWrapper} {
        > div {
          transform: scale(1.08);
          animation: imgZoomIn 0.3s;
          transition-timing-function: ease-in-out;
        }
      }
    }
  }

  @keyframes imgZoomIn {
    from {
      transform: scale(1);
    }
    to {
      transform: scale(1.08);
    }
  }
`;

const style = {
  ContentBlockContainer,
  ContentBlockWrapper,
  ContentItemWrapper,
  InnerWrapper,
  IconImage,
  ImageWrapper,
  TextCTAWrapper,
  Title,
  Text,
  FrostedGlass
};

export default style;
